var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"justify-center":"","pa-2":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('message.page_not_found')))]),_c('icon-like',{attrs:{"size":"400px","color":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }